<template>
  <b-form-group
    label="Ürün Kategorisi"
    label-for="id_product_categories"
  >
    <validation-provider
      #default="{ errors }"
      name="Ürün Kategorisi"
      rules="required"
    >
      <v-select
        v-model="dataItem.id_product_categories"
        :options="dataList"
        label="title"
        :reduce="item => item.id"
        placeholder="Ürün Kategorisi"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'CategoryCard',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['productCategories/dataList']
    },
    dataItem() {
      return this.$store.getters['products/dataItem']
    },
  },
  created() {
    localize('tr')
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('productCategories/getDataList', {
        select: [
          'product_categories.id AS id',
          'product_categories.title AS title',
        ],
        where: {
          'product_categories.status': 1,
        },
      })
    },
  },
}
</script>
